import { Model } from "pinia-orm";
import { Str, Uid } from "pinia-orm/decorators";
import type { AccountInfo } from "@azure/msal-browser";

export default class Account extends Model implements AccountInfo {
  static entity = "accounts";
  static primaryKey = "localAccountId";

  @Uid() declare localAccountId: string;
  @Str("") declare environment: string;
  @Str("") declare tenantId: string;
  @Str("") declare username: string;
  @Str("") declare homeAccountId: string;
  @Str("") declare name: string;
  @Str("") declare graphPhoto: string;
}
// import { ref } from "vue";
// import { defineStore } from "pinia";
// import type { UserInfo } from "@/types/index";

// export const useUserStore = defineStore("user", () => {
//   const currentUser = ref<UserInfo>(null);
//   const users = ref<UserInfo[]>([]);

//   const getUserById = computed(() => {
//     return (id: string) => users.value.find((user) => user?.id === id);
//   });

//   function updateCurrentUser(userInfo: Partial<UserInfo>) {
//     if (currentUser.value) {
//       Object.assign(currentUser.value, userInfo);
//     } else {
//       currentUser.value = userInfo;
//     }
//   }
//   function updateUsers(userList: UserInfo[]) {
//     users.value = userList;
//   }

//   function updateUser(userId: String, user: Partial<UserInfo>) {
//     if (userId && user) {
//       const foundUser = users.value.find((item) => item?.id === userId);
//       if (foundUser) {
//         Object.assign(foundUser, user);
//       }
//     }
//   }

//   return { user: currentUser, users, updateUser, updateCurrentUser, updateUsers, getUserById };
// });
